import { faHandHoldingDollar, faLocationDot, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import "./User_Info.css";

const User_Info = ({ User, Address, Mode }) => {

    const formattedAddress = [
        Address?.building,
        Address?.floor,
        Address?.apartment,
        Address?.street,
        Address?.direction,
        Address?.Users_Address_Detail?.City?.name,
        Address?.Users_Address_Detail?.State?.name,
        Address?.Users_Address_Detail?.Country?.name,
        Address?.Users_Address_Detail?.Pincode?.name,
        Address?.Users_Address_Detail?.Area?.name,
    ].filter(Boolean).join(", ");
    return (
        <section className="User_Info">
            <div className='main_profile_container'>

                <div className='icon_text_holder'>
                    <div className='icon_holder'>
                        <FontAwesomeIcon icon={faUser} className="icon" />
                    </div>
                    <div className='text_holder'>
                        <p className='username'>{User?.name || ""}</p>
                        <p className='contact'>{User?.contact_no || ""}</p>
                    </div>
                </div>

                <div className='icon_text_holder'>
                    <div className='icon_holder'>
                        <FontAwesomeIcon icon={faLocationDot} className="icon" />
                    </div>
                    <div className='text_holder'>
                        <p>{formattedAddress ? formattedAddress : "No Address Found"}</p>
                    </div>
                </div>

                <div className='icon_text_holder'>
                    <div className='icon_holder'>
                        <FontAwesomeIcon icon={faHandHoldingDollar} className='icon' />
                    </div>
                    <div className='text_holder'>
                        <p className='pay'>{Mode || ""}</p>
                    </div>
                </div>
            </div>



        </section>
    )
}

export default User_Info
